export default "__VITE_ASSET__BZZO9wHK__"